import React from 'react';
import fadeInAndOut from 'src/components/animations/SkeletonFadeInAndOut';
import styled from 'styled-components';
import { RANDOM_COLUMNS, TEST_ID_PRICE_CHART_PREVIEW } from '../../constants';

export const PriceChartPreview = (): JSX.Element => (
  <Container data-testid={TEST_ID_PRICE_CHART_PREVIEW}>
    <ColumnsContainer>
      {RANDOM_COLUMNS.map((height, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <ColumnLoader $columnHeight={height} key={index} />
      ))}
    </ColumnsContainer>
    <TextContainer>
      <TextLoader $width={44} />
      <TextLoader $width={64} />
    </TextContainer>
  </Container>
);

const Container = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  height: 100%;
  display: block;
  border-radius: 8px;
  background-color: white;
  padding: 8px 0;
`;

const ColumnsContainer = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: center;
  height: 40px;
  padding-top: 8px;
  width: 100%;
  align-items: flex-end;
  margin-bottom: 20px;

  & div + div {
    margin-left: 1px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding: 8px 0;
  justify-content: space-around;
`;

const TextLoader = styled.div<{ $width: number }>`
  height: 1px;
  margin: 7.5px;
  width: ${(props) => props.$width}px;
  background-color: #e6e6e6;
  position: relative;
  overflow: hidden;

  animation: ${fadeInAndOut} 1200ms ease-in-out infinite;
`;

const ColumnLoader = styled.div<{ $columnHeight: number }>`
  min-width: 34px;
  border-radius: 8px;
  height: ${({ $columnHeight }) => `${$columnHeight}px`};
  background-color: #e6e6e6;

  position: relative;
  overflow: hidden;

  animation: ${fadeInAndOut} 1200ms ease-in-out infinite;
`;
